import React, { memo } from "react";
import {
  Box,
  Typography,
  Paper,
  Avatar,
  AvatarGroup,
  Chip,
  useTheme,
  useMediaQuery,
  Button,
} from "@mui/material";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import StarIcon from "@mui/icons-material/Star";
import TickIcon from "../../../assets/icons/tick.png";
import PlusIcon from "../../../assets/icons/plus.png";
import UniversityBuilding from "../../../assets/icons/university.png";
import LockIcon from "../../../assets/icons/lock.png";
import MaleStudent from "../../../assets/icons/male_student.png";
import FemaleStudent from "../../../assets/icons/female_student.png";
import { useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
// @ts-ignore
import "react-multi-carousel/lib/styles.css";
import { testomonials } from "../utils/util";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

interface RightPanelProps {
  isShowInsurance?: boolean;
  isShowRating?: boolean;
  isShowInfo?: boolean;
  currentStep?: number;
}

const transformingFeatures = (currentStep: any) => [
  <Paper
    elevation={0}
    sx={{
      p: 3,
      borderRadius: 2,
      border: "1px solid",
      borderColor: "grey.200",
      bgColor: "#ffffff",
    }}
  >
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: "0.875rem",
        color: "#000",
        mb: 1.5,
        letterSpacing: "0.05em",
      }}
    >
      Transforming Futures Through{" "}
      <span style={{ color: "#006763" }}> Education Loans</span>
    </Typography>

    <Box sx={{ display: "flex", alignItems: "center", gap: 3, mt: 4 }}>
      <Box>
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: "1.725rem",
            color: "#006763",
          }}
        >
          72k+
        </Typography>
      </Box>
      <AvatarGroup
        max={3}
        sx={{
          "& .MuiAvatar-root": {
            width: 38,
            height: 38,
            fontSize: "0.7rem",
            bgcolor: "primary.light",
          },
        }}
      >
        <Avatar>SJ</Avatar>
        <Avatar sx={{ bgcolor: "secondary.main" }}>MK</Avatar>
        <Avatar sx={{ bgcolor: "primary.dark" }}>AR</Avatar>
      </AvatarGroup>
    </Box>
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: "0.8rem",
        color: "#000",
        mb: 1.5,
        letterSpacing: "0.05em",
      }}
    >
      Network of students
    </Typography>
  </Paper>,
  <Paper
    elevation={0}
    sx={{
      p: 3,
      borderRadius: 2,
      border: "1px solid",
      borderColor: "grey.200",
      bgColor: "#ffffff",
      mb: currentStep === 2 ? { xs: 2.5, sm: 0 } : {},
    }}
  >
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: "0.875rem",
        color: "#000",
        mb: 1.5,
        letterSpacing: "0.05em",
      }}
    >
      Transforming Futures Through{" "}
      <span style={{ color: "#006763" }}> Education Loans</span>
    </Typography>

    <Box sx={{ display: "flex", alignItems: "center", gap: 3, mt: 4 }}>
      <Box>
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: "1.725rem",
            color: "#006763",
          }}
        >
          1800+
        </Typography>
      </Box>
    </Box>
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: "0.8rem",
        color: "#000",
        mb: 1.5,
        letterSpacing: "0.05em",
      }}
    >
      Institutes
    </Typography>
  </Paper>,
  <Paper
    elevation={0}
    sx={{
      p: 3,
      borderRadius: 2,
      border: "1px solid",
      borderColor: "grey.200",
      bgColor: "#ffffff",
      mb: currentStep === 2 ? { xs: 2.5, sm: 0 } : {},
    }}
  >
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: "0.875rem",
        color: "#000",
        mb: 1.5,
        letterSpacing: "0.05em",
      }}
    >
      Transforming Futures Through{" "}
      <span style={{ color: "#006763" }}> Education Loans</span>
    </Typography>

    <Box sx={{ display: "flex", alignItems: "center", gap: 3, mt: 4 }}>
      <Box>
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: "1.725rem",
            color: "#006763",
          }}
        >
          51
        </Typography>
      </Box>
    </Box>
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: "0.8rem",
        color: "#000",
        mb: 1.5,
        letterSpacing: "0.05em",
      }}
    >
      Countries
    </Typography>
  </Paper>,
];

const RightPanel: React.FC<RightPanelProps> = ({
  isShowInsurance,
  isShowRating,
  isShowInfo,
  currentStep,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        width: isMobile ? "100%" : 240,
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        gap: 4,
        py: 3,
        mb: { xs: "90px", sm: "0px" },
      }}
    >
      {/* Security Card */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 2,
          border: "1px solid",
          borderColor: "#ffffff",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2.2, mb: 1.5 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: "16px",
              bgcolor: "#EBF5F6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={LockIcon} alt="Lock" width="16px" height="21px" />
          </Box>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "0.875rem",
              color: "text.primary",
            }}
          >
            Bank-Grade Security
          </Typography>
        </Box>
        <Typography
          sx={{ fontSize: "0.75rem", color: "text.secondary", lineHeight: 1.6 }}
        >
          Your data is encrypted using 256-bit protocols and stored in secure
          private environments.
        </Typography>
      </Paper>

      {/* Transforming Futures Through */}
        <Carousel
          swipeable={true}
          draggable={true}
          showDots={false}
          key={window.location.pathname || "loan-products-carousel"}
          infinite={true}
          arrows={false}
          ssr={true}
          autoPlay={true}
          responsive={responsive}
          autoPlaySpeed={10000}
          keyBoardControl={true}
          customTransition="transform 300ms ease-in-out"
          removeArrowOnDeviceType={["tablet", "mobile"]}
          deviceType={isMobile ? "mobile" : "desktop"}
          dotListClass="custom-dot-list-style"
          partialVisible={true}
          centerMode={false}
          minimumTouchDrag={50}
          itemClass="carousel-item-padding-auth"
          containerClass="carousel-container"
        >
          {transformingFeatures(currentStep)?.map((item) => (
            <>{item}</>
          ))}
        </Carousel>

      {/* Insurance upsell banner */}
      {isShowInsurance && (
        <Paper
          elevation={0}
          sx={{
            mt: 3,
            p: 3,
            borderRadius: 2.5,
            bgcolor: "#0067630F",
            transition: "border-color 0.2s",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontSize: "0.65rem",
                  fontWeight: 700,
                  color: "primary.light",
                  letterSpacing: "0.1em",
                  mb: 0.5,
                  textTransform: "uppercase",
                }}
              >
                Insurance
              </Typography>
              <Typography sx={{ fontWeight: 700, fontSize: "1rem", mb: 0.75 }}>
                Protect Your Future
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.78rem",
                  lineHeight: 1.5,
                  mb: 1.5,
                }}
              >
                Secure your peace of mind with our comprehensive Loan Protection
                Insurance.
              </Typography>
              <Box
                sx={{
                  padding: "10px",
                  bgcolor: "#f9f4f4",
                  borderRadius: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <img
                    src={TickIcon}
                    alt="tick"
                    width={16}
                    style={{ marginRight: 8 }}
                  />
                  <Typography sx={{ fontSize: "0.78rem" }}>
                    Covers loan repayment in case of emergencies, illness, or
                    job loss.
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Button
              variant="contained"
              size="small"
              startIcon={
                <img
                  src={PlusIcon}
                  alt="tick"
                  width={16}
                  style={{ marginRight: 8 }}
                />
              }
              onClick={() => console.log("called")}
              sx={{
                borderRadius: 2,
                fontSize: "0.8rem",
                whiteSpace: "nowrap",
                py: 1,
              }}
            >
              Add to Application
            </Button>
          </Box>
        </Paper>
      )}

      {/* Testimonial */}
      {isShowRating && (
        <Carousel
          swipeable={true}
          draggable={true}
          showDots={false}
          key={window.location.pathname || "loan-products-carousel"}
          infinite={true}
          arrows={false}
          ssr={true}
          autoPlay={true}
          responsive={responsive}
          autoPlaySpeed={5000}
          keyBoardControl={true}
          customTransition="transform 300ms ease-in-out"
          removeArrowOnDeviceType={["tablet", "mobile"]}
          deviceType={isMobile ? "mobile" : "desktop"}
          dotListClass="custom-dot-list-style"
          partialVisible={true}
          centerMode={false}
          minimumTouchDrag={50}
          itemClass="carousel-item-padding-auth"
          containerClass="carousel-container"
        >
          {testomonials.map((item: any) => (
            <Paper
              elevation={0}
              key={item.text}
              sx={{
                p: 4,
                borderRadius: 3,
                minHeight: { xs: "380px", sm: "456px" },
                bgcolor: "#00837E",
                color: "white",
                mb: { xs: 2, sm: 0 },
                position: "relative",
                overflow: "hidden",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: -30,
                  right: -30,
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  bgcolor: "#00837E",
                },
              }}
            >
              <Box sx={{ display: "flex", mb: 1 }}>
                {[...Array(item.rating)].map((_, i) => (
                  <StarIcon key={i} sx={{ fontSize: 21, color: "#FFC703" }} />
                ))}
              </Box>
              <Typography
                sx={{
                  fontSize: "18px",
                  color: "#FFFFFF",
                  lineHeight: 1.6,
                  mb: 2,
                }}
              >
                {item.text}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <img
                  src={item.studentImage}
                  alt="student"
                  width={40}
                  height={40}
                  style={{ borderRadius: "50%" }}
                />

                <Box>
                  <Typography
                    sx={{ fontSize: "14px", fontWeight: 700, color: "white" }}
                  >
                    {item.studentName}
                  </Typography>
                  <Typography sx={{ fontSize: "12", color: "#F3FFFDCC" }}>
                    {item.studentDetails}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          ))}
        </Carousel>
      )}

      {isShowInfo && (
        <Box sx={{ mb: { xs: 2.5, sm: 0 } }}>
          <img
            src={UniversityBuilding}
            alt="University Building"
            width="100%"
            height="auto"
          />
        </Box>
      )}

      {/* Need Help */}
      {/* <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 2,
          border: "1px solid",
          borderColor: "grey.200",
          display: "flex",
          alignItems: "center",
          gap: 2,
          cursor: "pointer",
          "&:hover": { borderColor: "primary.main", bgcolor: "primary.50" },
          transition: "all 0.2s",
        }}
      >
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: 2,
            bgcolor: "grey.100",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <HeadsetMicOutlinedIcon
            sx={{ fontSize: 18, color: "primary.main" }}
          />
        </Box>
        <Box>
          <Typography
            sx={{ fontSize: "14px", fontWeight: 600, color: "text.primary" }}
          >
            Need help?
          </Typography>
          <Typography
            sx={{
              fontSize: "12px",
              color: "#3D4948",
              textDecoration: "underline",
              fontWeight: 500,
            }}
          >
            Talk to a financial mentor
          </Typography>
        </Box>
      </Paper> */}
    </Box>
  );
};

export default memo(RightPanel);
